// import Alpine from 'alpinejs';

import _ from 'lodash';

import QumanoLogService from '@/modules/general/g--qumano/service.js';

export const B__Qumano = () => ({
    qumanoIsActive: false,
    qumanoIsLoading: false,
    spinnerStatus: 'idle',

    init() {},

    setSpinnerStatus(status) {
        if (status == 'done') {
            setTimeout(() => {
                return 'idle';
            }, 800);
        } else {
            return status;
        }
    },

    async initiate() {
        if (window.qumano) {
            if (!this.qumanoIsActive) {
                this.qumanoIsLoading = true;
                this.spinnerStatus = this.setSpinnerStatus('loading'); // show spinner

                const wpLogId = JSON.parse(
                    localStorage.getItem('qumano-wp-log-id')
                );

                QumanoLogService.get({ wpLogId: wpLogId }).then((res) => {
                    console.log(res);

                    if (res.data.post_status == 'draft') {
                        // reuse the existing log
                        console.log('reuse the existing log');

                        this.initQumano(wpLogId);
                    } else {
                        // create a new log
                        console.log('create a new log');

                        QumanoLogService.create({
                            action: 'start'
                        }).then((res) => {
                            console.log(res);

                            /*
                             * 1. Create a new Qumano Log
                             * or use existing if it has a post status of draft (meaning the first flow was not finished) ?
                             */
                            const newWpLogId = res.data.wp_log_id;

                            // add the WP Log ID to Qumano Localstorage
                            localStorage.setItem(
                                'qumano-wp-log-id',
                                JSON.stringify(newWpLogId)
                            );

                            this.initQumano(newWpLogId);
                        });
                    }
                });
            }
        }
    },

    async initQumano(LogId) {
        setTimeout(() => {
            window
                .qumano({
                    API_KEY: 12341234, // not in use yet
                    elemSelector: '#qumano-widget-app',
                    id: 1,
                    flowId: 1,
                    appPath:
                        window.location.origin +
                        '/app/themes/umano/modules/general/g--qumano/app'
                })
                .then((res) => {
                    console.log(res);
                    this.qumanoIsActive = true;
                    this.qumanoIsLoading = false;

                    setTimeout(() => {
                        this.spinnerStatus = this.setSpinnerStatus('done');
                    }, 1000);
                });

            window.addEventListener('qumano-checkout', (e) => {
                console.log({ ...e.detail.appState });

                const appState = e.detail.appState;
                console.log(appState);

                // localStorage.setItem(
                //     'qumano-checkout',
                //     JSON.stringify(appState)
                // );

                const wpLogId = JSON.parse(
                    localStorage.getItem('qumano-wp-log-id')
                );

                // calc product recommendations before redirecting / LP - Product recommendations

                this.findScenarioData(appState).then((scenario) => {
                    localStorage.setItem(
                        'recommended-products-from-qumano',
                        JSON.stringify(scenario.recommendations)
                    );

                    localStorage.setItem(
                        'qumano-scenario-data',
                        JSON.stringify(scenario)
                    );

                    QumanoLogService.update({
                        action: 'questions-completed',
                        flow: 1,
                        wpLogId: wpLogId,
                        appState: appState,
                        recommendedProducts: scenario.recommendations
                    }).then((res) => {
                        console.log(res);
                        // add the WP Log ID to Qumano Localstorage
                        console.log('REDIRECT NOW');
                        setTimeout(() => {
                            window.location.href =
                                window.location.origin +
                                '/recommended-products';
                        }, 500);
                    });
                });
            });
        }, 500);
    },
    /**
     *
     * Sophion : there will only be 1 scenario
     * @returns
     */
    async findScenarioData(appState) {
        const scenario = appState.scenarios.find(
            (scenario) => scenario.type == 'result'
        );

        // feature : get from client custom result data object (feature which could be implemented in qumano CMS to provide client customization results)
        return scenario.result.data;

        // Not in use but another way of logic where the recommendartoins are filtered from a prop on each field option (filter_ex)
        const possibleProducts = ['Qube', 'QP16', 'QP48', 'QPC'];

        const exclusionFilter = (values) => {
            const res = [];

            const filter = values.map((field) => {
                // console.log(field.value);
                // console.log(field.value.filter_ex);

                if (Array.isArray(field.value.filter_ex)) {
                    /** compare field.value.filter_ex (array) with possibleProducts (array)
                     * If matching value is found, then remove it from possibleProducts
                     * */
                    field.value.filter_ex.map((ex) => {
                        if (possibleProducts.includes(ex)) {
                            const index = possibleProducts.indexOf(ex);
                            if (index > -1) {
                                possibleProducts.splice(index, 1);
                            }
                        }
                    });
                }
                // console.log('------------------');
            });

            // const filter = objectMap(values, res, function (value) {
            //     console.log(value);
            //     return value.filter_ex;
            // });

            return filter;
        };

        // const obj = JSON.parse(localStorage.getItem('qumano-checkout'));

        exclusionFilter(appState.values);

        const recommendedProducts = possibleProducts;
        console.log('Receommended Products : ', possibleProducts);

        return recommendedProducts;
    }
});
